import React, { useState, useMemo, useEffect } from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  LineChart,
  Line,
} from "recharts";
import CustomDateFilter from "../../../../CustomDatePicker/DateFilterSelect";
import DateFilterSelect from "../../../../CustomDatePicker/DateFilterSelectold";
import { ChevronLeft, FileChartColumnIncreasing, Funnel } from "lucide-react";
import {
  FileText,
  BadgeCheck,
  XCircle,
  RefreshCw,
  Hourglass,
  Wallet,
  RotateCw,
  MessageCircle,
  Eye,
  Share2,
  Calendar,
} from "lucide-react";
import ScheduleNACHModal from "./ScheduleNACHModal";
import ActionMenu from "./ActionMenu";
import moment from "moment";
import Loader from '../../../../presentationals/Loader/Loader.component'

import {
  getOverviewNachDataByFilters, getNachListDataByMultiFilters,
  getFailureReasonListForGraph, getBankFailureReasonListForGraph,
  getRetrySuccessRateForGraph, getDailyTrendRangeFromFilters,
  downloadNachactiveApi, getAlertsListByFiltersDate
} from "../../MISNew/API's/Actioncreator";

<style>{`
       
        @keyframes shimmer {
         0% {
            background-position: 200% 0;
            }
        100% {
          background-position: -200% 0;
        }
        }
        
      `}</style>


const ICON_SIZE = 18;

const COLOR_PALETTE = [
  "#06B6D4", // cyan
  "#6366F1", // indigo
  "#8B5CF6", // violet
  "#10B981", // green
  "#F59E0B", // amber
  "#EF4444", // red
  "#3B82F6", // blue
  "#EC4899", // pink
  "#F97316", // orange
  "#14B8A6"  // teal
];





// const ALERTS = [
//   {
//     id: 1,
//     type: "warning",
//     icon: "⚠️",
//     title: "320 Mandate failed",
//     desc: "due to Insufficient Balance",
//     bg: "#fefce8",
//     border: "#fde68a",
//     iconColor: "#d97706",
//   },
//   {
//     id: 2,
//     type: "error",
//     icon: "⚠️",
//     title: "50 Mandates exceeded",
//     desc: "retry limit",
//     bg: "#fff1f2",
//     border: "#fecdd3",
//     iconColor: "#dc2626",
//   },
//   {
//     id: 3,
//     type: "info",
//     icon: "🔺",
//     title: "120 Mandates Cancelled",
//     desc: "by customer",
//     bg: "#f9fafb",
//     border: "#e5e7eb",
//     iconColor: "#6b7280",
//   },
// ];

// ─── Shared style helpers ─────────────────────────────────────
const card = {
  background: "#ffffff",
  borderRadius: 12,
  border: "1px solid #e5e7eb",
  boxShadow: "0 1px 3px rgba(0,0,0,0.06)",
};

const badge = (bg, color) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  padding: "5px 10px",
  borderRadius: 8,
  fontSize: 12,
  fontWeight: 500,
  background: bg,
  color,
  whiteSpace: "nowrap",
});

const btn = (primary = false) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 6,
  padding: "8px 16px",
  borderRadius: 8,
  fontSize: 13,
  fontWeight: 500,
  cursor: "pointer",
  border: primary ? "none" : "1px solid #e5e7eb",
  background: primary ? "#035865" : "#66ACAF5C",
  color: primary ? "#ffffff" : "#035865",
  whiteSpace: "nowrap",
  transition: "opacity 0.15s",
});

// ─── Sub-components ───────────────────────────────────────────

function StatCard({ stat }) {
  if (stat.dark) {
    return (
      <div
        style={{
          ...card,
          background: "linear-gradient(135deg, #035865 0%, #25A3B6 100%)",
          border: "none",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          flex: "1 1 160px",
          minWidth: 160,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <span style={{ fontSize: 13, fontWeight: 500, color: "white" }}>
            {stat.label}
          </span>
          <div
            style={{
              width: 36,
              height: 36,
              borderRadius: 8,
              background: "rgba(255,255,255,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Wallet size={22} color="#ffffff" />
          </div>
        </div>
        <div
          style={{
            fontSize: 26,
            fontWeight: 500,
            color: "#ffffff",
            letterSpacing: "-0.02em",
          }}
        >
          {stat.value}
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        ...card,
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        flex: "1 1 140px",
        minWidth: 140,
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span style={{ fontSize: 13, fontWeight: 500, color: "#6b7280" }}>
          {stat.label}
        </span>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: 8,
            background: stat.gradient,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {stat.icon}
        </div>
      </div>
      <div
        style={{
          fontSize: 26,
          fontWeight: 500,
          color: "#111827",
          letterSpacing: "-0.02em",
        }}
      >
        {stat.value}
        {stat.change && (
          <div
            style={{
              fontSize: 12,
              fontWeight: 500,
              color: stat.trend === "up" ? "#16a34a" : "#dc2626",
            }}
          >
            {stat.change}
          </div>
        )}
      </div>
    </div>
  );
}

function NachStatusIcon({ status }) {
  return (status == "true" || status == true) ? (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 18,
        height: 18,
        borderRadius: 4,
        border: "1.5px solid #16a34a",
        color: "#16a34a",
        fontSize: 13,
      }}
    >
      ✓
    </span>
  ) : (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: 18,
        height: 18,
        borderRadius: 4,
        border: "1.5px solid #dc2626",
        color: "#dc2626",
        fontSize: 13,
      }}
    >
      ✗
    </span>
  );
}

function TruncatedTooltip({ text, color, maxLength = 20 }) {
  const [visible, setVisible] = React.useState(false);
  const [pos, setPos] = React.useState({ top: 0, left: 0 });
  const spanRef = React.useRef(null);

  const isTruncated = text && text.length > maxLength;
  const displayText = isTruncated ? text.slice(0, maxLength) + "…" : text;

  const handleMouseEnter = () => {
    if (!isTruncated || !spanRef.current) return;
    const rect = spanRef.current.getBoundingClientRect();
    setPos({
      top: rect.bottom + window.scrollY + 6,
      left: rect.left + window.scrollX + rect.width / 2,
    });
    setVisible(true);
  };

  const handleMouseLeave = () => setVisible(false);

  return (
    <>
      <div
        style={{ display: "flex", alignItems: "center", gap: 6 }}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {
          displayText && displayText?.length > 0 ?
            <>
              <span
                style={{
                  width: 8,
                  height: 8,
                  borderRadius: "50%",
                  background: color ?? "#dc2626",
                  flexShrink: 0,
                }}
              />
              <span
                ref={spanRef}
                style={{
                  fontSize: 13,
                  color: "#374151",
                  whiteSpace: "nowrap",
                  cursor: 'pointer'
                }}
              >
                {displayText && displayText?.length > 0 ? displayText : "-"}
              </span>
            </>
            :
            <span
              ref={spanRef}
              style={{
                fontSize: 13,
                color: "#374151",
                whiteSpace: "nowrap",
              }}
            >
              -
            </span>
        }
      </div>

      {visible && isTruncated && (
        <div
          style={{
            position: "fixed",
            top: pos.top,
            left: pos.left,
            transform: "translateX(-50%)",
            zIndex: 9999,
            background: "#1f2937",
            color: "#f9fafb",
            fontSize: 12,
            lineHeight: 1.5,
            padding: "7px 12px",
            borderRadius: 8,
            maxWidth: 260,
            whiteSpace: "normal",
            wordBreak: "break-word",
            boxShadow: "0 4px 12px rgba(0,0,0,0.18)",
            pointerEvents: "none",
          }}
        >
          <div
            style={{
              position: "absolute",
              top: -5,
              left: "50%",
              transform: "translateX(-50%)",
              width: 0,
              height: 0,
              borderLeft: "5px solid transparent",
              borderRight: "5px solid transparent",
              borderBottom: "5px solid #1f2937",
            }}
          />
          {text}
        </div>
      )}
    </>
  );
}

function CustomPieLegend({ data }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 8,
        marginTop: 12,
        height: '80px',
        overflowY: 'auto',
        scrollbarWidth: 'thin'
      }}
    >
      {data.map((d) => (
        <div
          key={d.name}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 8,
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <div
              style={{
                width: 10,
                height: 10,
                borderRadius: "50%",
                background: d.color,
                flexShrink: 0,
              }}
            />
            <span style={{ fontSize: 12, color: "#6b7280" }}>{d.name}</span>
          </div>
          <span style={{ fontSize: 12, fontWeight: 600, color: "#374151" }}>
            {d.value}%
          </span>
        </div>
      ))}
    </div>
  );
}

const TableRowSkeleton = ({ columns = 10 }) => {
  return (
    <tr style={{ borderBottom: "1px solid #f3f4f6" }}>
      {Array.from({ length: columns }).map((_, idx) => (
        <td
          key={idx}
          style={{
            padding: "12px 16px",
            textAlign: "center",
          }}
        >
          <div
            style={{
              height: 14,
              width: idx === 7 ? "80%" : "60%",
              margin: "0 auto",
              borderRadius: 6,
              background:
                "linear-gradient(90deg, #f3f4f6 25%, #e5e7eb 50%, #f3f4f6 75%)",
              backgroundSize: "200% 100%",
              animation: "shimmer 1.2s infinite",
            }}
          />
        </td>
      ))}
    </tr>
  );
};

// ─── Main Dashboard ───────────────────────────────────────────
export default function Dashboard({
  commonFilter,
  handleBack,
  serviceProvider, setServiceProvider,
  handleFilter,
  gatewayList,
  retryFilter,
  setRetryFilter
}) {
  const [loader, setLoader] = useState(false);
  const [tableloader, setTableLoader] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [status, setStatus] = useState("");
  // const [retryFilter, setRetryFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const itemsPerPage = 10;
  const [isFilterCleared, setIsFilterCleared] = useState(false);
  const menuOpen = Boolean(anchorEl);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [DAILY_TREND, setDAILY_TREND] = useState([
    // { day: "Mon", success: 420, failed: 180 },
    // { day: "Tue", success: 500, failed: 200 },
    // { day: "Wed", success: 570, failed: 260 },
    // { day: "Thu", success: 470, failed: 160 },
    // { day: "Fri", success: 510, failed: 200 },
    // { day: "Sat", success: 460, failed: 150 },
  ]);
  const [RETRY_LINE, setRETRY_LINE] = useState([
    // { name: "Retry 1", rate: 38 },
    // { name: "Retry 2", rate: 28 },
    // { name: "Retry 3", rate: 8 },
  ]);
  const [BANK_BAR, setBANK_BAR] = useState([
    // { bank: "SBI", rate: 13 },
    // { bank: "HDFC", rate: 9 },
    // { bank: "ICICI", rate: 7 },
    // { bank: "Axis", rate: 4 },
  ]);
  const [FAILURE_PIE, setFAILURE_PIE] = useState([
    // { name: "Insufficient Balance", value: 40, color: "#22d3ee" },
    // { name: "Technical Failure", value: 20, color: "#818cf8" },
    // { name: "Account Closed", value: 15, color: "#a78bfa" },
    // { name: "Mandate Cancelled", value: 25, color: "#34d399" },
  ])
  const [STATS, setSTATS] = useState([
    // {
    //   id: 1,
    //   label: "Total NACH",
    //   value: "—",
    //   icon: <FileText size={ICON_SIZE} color="white" />,
    //   gradient: "linear-gradient(135deg, #0088FF 0%, #92CCFF 100%)",
    //   change: null,
    // },
    // {
    //   id: 2,
    //   label: "Successful",
    //   value: "—",
    //   icon: <BadgeCheck size={ICON_SIZE} color="white" />,
    //   gradient: "linear-gradient(135deg, #327E45 0%, #9ED3AB 100%)",
    //   change: null,
    //   trend: "up",
    // },
    // {
    //   id: 3,
    //   label: "Failed",
    //   value: "—",
    //   icon: <XCircle size={ICON_SIZE} color="white" />,
    //   gradient: "linear-gradient(135deg, #E84E4E 0%, #FF424275 100%)",
    //   change: null,
    // },
    // {
    //   id: 4,
    //   label: "Retry Count",
    //   value: "—",
    //   icon: <RefreshCw size={ICON_SIZE} color="white" />,
    //   gradient: "linear-gradient(135deg, #8A38F5 0%, #8A38F51A 100%)",
    //   change: null,
    // },
    // {
    //   id: 5,
    //   label: "Pending",
    //   value: "—",
    //   icon: <Hourglass size={ICON_SIZE} color="white" />,
    //   gradient: "linear-gradient(135deg, #CFA902 0%, #FFDC4275 100%)",
    //   change: null,
    // },
    // {
    //   id: 6,
    //   label: "Total EMI Amount",
    //   value: "—",
    //   icon: <Wallet size={ICON_SIZE} color="white" />,
    //   gradient: "linear-gradient(135deg, #035865 0%, #25A3B6 100%)",
    //   dark: true,
    // },
  ]);

  const [ALERTS, setALERTS] = useState([
    // {
    //   id: 1,
    //   type: "warning",
    //   icon: "⚠️",
    //   title: "320 Mandate failed",
    //   desc: "due to Insufficient Balance",
    //   bg: "#fefce8",
    //   border: "#fde68a",
    //   iconColor: "#d97706",
    // },
    // {
    //   id: 2,
    //   type: "error",
    //   icon: "⚠️",
    //   title: "50 Mandates exceeded",
    //   desc: "retry limit",
    //   bg: "#fff1f2",
    //   border: "#fecdd3",
    //   iconColor: "#dc2626",
    // },
    // {
    //   id: 3,
    //   type: "info",
    //   icon: "🔺",
    //   title: "120 Mandates Cancelled",
    //   desc: "by customer",
    //   bg: "#f9fafb",
    //   border: "#e5e7eb",
    //   iconColor: "#6b7280",
    // },
  ])

  // ─── Overview API: fires when date range or service provider changes ───────
  useEffect(() => {
    const obj = {
      from: commonFilter.fromDate,
      to: commonFilter.toDate,
      provider: serviceProvider,
    };
    overviewAPI(obj);
  }, [commonFilter.fromDate, commonFilter.toDate, serviceProvider]);


  useEffect(() => {
    setCurrentPage(0);
  }, [
    searchTerm,
    status,
    retryFilter,
    serviceProvider,
    commonFilter.fromDate,
    commonFilter.toDate,
  ]);

  // Fetch table data whenever currentPage or any filter changes
  useEffect(() => {
    const payload = {
      from: commonFilter.fromDate,
      to: commonFilter.toDate,
      provider: serviceProvider,
      search: searchTerm,
      status,
      retry: retryFilter,
      page: currentPage,
    };
    tableAPI(payload);
  }, [
    commonFilter.fromDate,
    commonFilter.toDate,
    serviceProvider,
    searchTerm,
    status,
    retryFilter,
    currentPage,
  ]);

  // ─── Date filter change handler (clean, no double-set) ───────────────────
  const handleDateFilterPopup = (type, val) => {
    const formatted = moment(val).format("YYYY-MM-DD");
    if (type === "from" && commonFilter.fromDate !== formatted) {
      handleFilter("fromDate", formatted);
    } else if (type === "to" && commonFilter.toDate !== formatted) {
      handleFilter("toDate", formatted);
    }
  };

  // ─── API callers ──────────────────────────────────────────────────────────
  const overviewAPI = (data) => {
    setLoader(true);
    let pendingCalls = 6; // total APIs

    const handleDone = () => {
      pendingCalls -= 1;
      if (pendingCalls === 0) {
        setLoader(false);
      }
    };

    getOverviewNachDataByFilters(
      moment(data.from).format("DD-MM-YYYY"),
      moment(data.to).format("DD-MM-YYYY"),
      data.provider ?? "",
      (callback) => {

        const d = callback?.data ?? {};
        setSTATS([
          {
            id: 1,
            label: "Total NACH",
            value: d.totalNach ?? "—",
            icon: <FileText size={ICON_SIZE} color="white" />,
            gradient: "linear-gradient(135deg, #0088FF 0%, #92CCFF 100%)",
            change: null,
          },
          {
            id: 2,
            label: "Successful",
            value: d.successful ?? "—",
            icon: <BadgeCheck size={ICON_SIZE} color="white" />,
            gradient:
              Number(d.successfulToday) > 0
                ? "linear-gradient(135deg, #327E45 0%, #9ED3AB 100%)"
                : "linear-gradient(135deg, #E84E4E 0%, #FF424275 100%)",
            change: d.successfulToday != null
              ? `${Number(d.successfulToday) > 0 ? "↗" : "↘"} ${d.successfulToday} Today`
              : null,
            trend: Number(d.successfulToday) > 0 ? "up" : "down",
          },
          {
            id: 3,
            label: "Failed",
            value: d.failed ?? "—",
            icon: <XCircle size={ICON_SIZE} color="white" />,
            gradient:
              Number(d.failedChangeThisWeek) > 0
                ? "linear-gradient(135deg, #327E45 0%, #9ED3AB 100%)"
                : "linear-gradient(135deg, #E84E4E 0%, #FF424275 100%)",
            change: d.failedChangeThisWeek != null
              ? `${Number(d.failedChangeThisWeek) > 0 ? "↗" : "↘"} ${d.failedChangeThisWeek} this Week`
              : null,
            trend: Number(d.failedChangeThisWeek) > 0 ? "up" : "down",
          },
          {
            id: 4,
            label: "Retry Count",
            value: d.retryCount ?? "—",
            icon: <RefreshCw size={ICON_SIZE} color="white" />,
            gradient: "linear-gradient(135deg, #8A38F5 0%, #8A38F51A 100%)",
            change: null,
          },
          {
            id: 5,
            label: "Pending",
            value: d.pending ?? "—",
            icon: <Hourglass size={ICON_SIZE} color="white" />,
            gradient: "linear-gradient(135deg, #CFA902 0%, #FFDC4275 100%)",
            change: null,
          },
          {
            id: 6,
            label: "Total EMI Amount",
            value: d.totalEmiAmount ?? "—",
            icon: <Wallet size={ICON_SIZE} color="white" />,
            gradient: "linear-gradient(135deg, #035865 0%, #25A3B6 100%)",
            dark: true,
          },
        ]);

        handleDone()
      }
    );
    getFailureReasonListForGraph(
      moment(data.from).format("DD-MM-YYYY"),
      moment(data.to).format("DD-MM-YYYY"),
      data.provider ?? "",
      (callback) => {

        const apiData = callback?.data?.reasons || [];

        const formatted = apiData.map((item, index) => ({
          name: item.reason,
          value: item.percentage,
          color: COLOR_PALETTE[index % COLOR_PALETTE.length] // ✅ auto assign
        }));

        setFAILURE_PIE(formatted ?? []);
        handleDone()
      }
    );
    getBankFailureReasonListForGraph(
      moment(data.from).format("DD-MM-YYYY"),
      moment(data.to).format("DD-MM-YYYY"),
      data.provider ?? "",
      (callback) => {

        setBANK_BAR(callback?.data?.banks ?? [])
        handleDone()
      }
    );
    getRetrySuccessRateForGraph(
      moment(data.from).format("DD-MM-YYYY"),
      moment(data.to).format("DD-MM-YYYY"),
      data.provider ?? "",
      (callback) => {

        setRETRY_LINE(callback?.data?.retryLevels ?? [])
        handleDone()
      }
    );
    getDailyTrendRangeFromFilters(
      moment(data.from).format("DD-MM-YYYY"),
      moment(data.to).format("DD-MM-YYYY"),
      data.provider ?? "",
      (callback) => {
        setDAILY_TREND(callback?.data?.dataPoints ?? [])
        // setRETRY_LINE(callback?.data?.retryLevels ?? [])
        handleDone()
      }
    );
    getAlertsListByFiltersDate(
      moment(data.from).format("DD-MM-YYYY"),
      moment(data.to).format("DD-MM-YYYY"),
      data.provider ?? "",
      (callback) => {
        if (callback && callback?.data?.alerts?.length > 0) {
          const configMap = {
            INSUFFICIENT_BALANCE: {
              id: 1,
              type: "warning",
              icon: "⚠️",
              bg: "#fefce8",
              border: "#fde68a",
              iconColor: "#d97706",
            },
            RETRY_LIMIT_EXCEEDED: {
              id: 2,
              type: "error",
              icon: "⚠️",
              bg: "#fff1f2",
              border: "#fecdd3",
              iconColor: "#dc2626",
            },
            MANDATE_CANCELLED: {
              id: 3,
              type: "info",
              icon: "🔺",
              bg: "#f9fafb",
              border: "#e5e7eb",
              iconColor: "#6b7280",
            }
          };
          const formattedAlerts = callback?.data?.alerts
            .filter(item => item?.description && configMap[item.type])
            .map(item => ({
              ...configMap[item.type],
              title: item.title,        // from API
              desc: item.description,   // from API
            }));

          setALERTS(formattedAlerts);
        } else {
          setALERTS([])
        }

        handleDone()
      }
    );

  };

  const tableAPI = (data) => {
    setTableLoader(true);
    getNachListDataByMultiFilters(
      data.search || "",
      moment(data.from).format("DD-MM-YYYY"),
      moment(data.to).format("DD-MM-YYYY"),
      data.retry || "",
      data.provider || "",
      data.status || "",
      data.page,        // 1-based page number
      itemsPerPage,
      (callback) => {
        setTableLoader(false);
        setTableData(callback?.data?.records || []);
        setTotalPages(callback?.data?.totalPages || 1);
        setTotalRecords(callback?.data?.totalElements ?? callback?.data?.totalElements ?? 0);
      }
    );
  };

  // ─── Pagination helpers ───────────────────────────────────────────────────
  // Build a smart page number array (e.g. 1 … 4 5 6 … 12) to avoid huge page lists
  const pageNumbers = useMemo(() => {
    if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i);
    const pages = new Set([0, totalPages - 1, currentPage]);
    if (currentPage > 0) pages.add(currentPage - 1);
    if (currentPage < totalPages - 1) pages.add(currentPage + 1);
    return [...pages].sort((a, b) => a - b);
  }, [totalPages, currentPage]);

  const selectStyle = {
    padding: "8px 32px 8px 12px",
    fontSize: 13,
    color: "#374151",
    background: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: 8,
    cursor: "pointer",
    outline: "none",
    appearance: "none",
    minWidth: 150,
  };

  const downloadNachAPIs = (type) => {
    setLoader(true)
    downloadNachactiveApi(moment(commonFilter?.fromDate).format("DD-MM-YYYY"), moment(commonFilter?.toDate).format("DD-MM-YYYY"), type, serviceProvider, callback => {
      setLoader(false)
    })
  }

  return (
    <>
      {loader ? <Loader /> : ""}
      <div
        style={{
          fontFamily: "'Inter','Segoe UI',sans-serif",
          background: "#f9fafb",
          minHeight: "100vh",
          padding: "24px 12px",
          display: "flex",
          flexDirection: "column",
          gap: 24,
        }}
      >
        {/* ── Header ── */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
          }}
        >
          <h1
            style={{
              fontSize: 20,
              fontWeight: 500,
              color: "#111827",
              letterSpacing: "-0.02em",
              margin: 0,
              display: "inline-flex",
              gap: "5px",
              cursor: "pointer",
            }}
            onClick={(e) => handleBack(e)}
          >
            <ChevronLeft style={{ width: "auto" }} /> NACH Management
          </h1>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            <select
              value={serviceProvider}
              onChange={(e) => setServiceProvider(e.target.value)}
              style={selectStyle}
            >
              <option value="">Service Provider's</option>
              {
                gatewayList?.length > 0 && gatewayList?.map((val) => {
                  return (
                    <option value={val}>{val?.charAt(0) + val?.slice(1)?.toLowerCase()}</option>
                  )
                })
              }

            </select>
            <button style={btn()} onClick={() => downloadNachAPIs(false)}>
              <span style={{ fontSize: 14 }}>⬇</span> Export Failed Only
            </button>
            <button style={btn(true)} onClick={() => downloadNachAPIs('')}>
              <span style={{ fontSize: 14 }}>⬇</span> Export to Excel
            </button>
          </div>
        </div>

        {/* ── Stat cards ── */}
        <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
          {STATS.map((s) => (
            <StatCard key={s.id} stat={s} />
          ))}
        </div>

        {/* ── Filter bar ── */}
        <div
          style={{
            ...card,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            flexWrap: "wrap",
            gap: 12,
            padding: "12px 16px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
              flex: 1,
              justifyContent: 'space-between'
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 8,
                flexWrap: "wrap",
                flex: 1,
              }}
            >
              {/* Search */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  padding: "8px 12px",
                  background: "#f9fafb",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  minWidth: 200,
                }}
              >
                <span style={{ color: "#9ca3af", fontSize: 14 }}>🔍</span>
                <input
                  type="text"
                  placeholder="Search by Loan ID or Customer..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  style={{
                    border: "none",
                    outline: "none",
                    background: "transparent",
                    fontSize: 13,
                    color: "#374151",
                    width: "100%",
                    fontFamily: "inherit",
                  }}
                />
              </div>

              {/* Date range picker */}
              <DateFilterSelect
                customStyle={{
                  padding: '8px 12px',
                  border: "1px solid rgb(229, 231, 235)",
                  background: "rgb(249, 250, 251)"
                }}
                value={[
                  new Date(commonFilter.fromDate),
                  new Date(commonFilter.toDate),
                ]}
                onChange={(range) => {
                  handleDateFilterPopup("from", range[0]);
                  handleDateFilterPopup("to", range[1]);
                }}
                isFilterCleared={isFilterCleared}
              />

              {/* Status filter */}
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                style={selectStyle}
              >
                <option value="">Status</option>
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>

              {/* Retry count filter */}
              <select
                value={retryFilter}
                onChange={(e) => setRetryFilter(e.target.value)}
                style={selectStyle}
              >
                <option value="">Retry Count</option>
                <option value="1">1</option>
                <option value="3">3</option>
                <option value="6">6</option>
              </select>
            </div>

            {/* Clear filters */}
            <button
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: 36,
                height: 36,
                borderRadius: 8,
                background: "#f3f4f6",
                color: "#6b7280",
                border: "1px solid #e5e7eb",
                cursor: "pointer",
                fontSize: 16,
              }}
              onClick={() => {
                setSearchTerm("");
                setStatus("");
                setRetryFilter("");
                setIsFilterCleared((v) => !v);
              }}
              title="Clear filters"
            >
              ✕
            </button>
          </div>
        </div>

        {/* ── Table ── */}
        <div style={{ ...card, overflow: "hidden" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "16px 20px",
              borderBottom: "1px solid #f3f4f6",
            }}
          >
            <span style={{ fontSize: 15, fontWeight: 600, color: "#111827" }}>
              NACH Transactions
            </span>
            {/* Show server-side total */}
            <span style={{ fontSize: 13, color: "#6b7280" }}>
              Total: {totalRecords} records
            </span>
          </div>

          <div style={{ overflowX: "auto", scrollbarWidth: 'thin' }}>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                minWidth: 900,
              }}
            >
              <thead>
                <tr
                  style={{
                    background: "#f9fafb",
                    borderBottom: "1px solid #e5e7eb",
                  }}
                >
                  {[
                    "Loan ID",
                    "Customer Name",
                    "Bank Name",
                    "NACH Status",
                    "Retry Count",
                    "Medium",
                    "Loan Status",
                    "Failure Reason",
                    "Last Attempt",
                    "Actions",
                  ].map((h) => (
                    <th
                      key={h}
                      style={{
                        padding: "10px 16px",
                        textAlign: "center",
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#6b7280",
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableloader ? (
                  Array.from({ length: 6 }).map((_, i) => (
                    <TableRowSkeleton key={i} columns={10} />
                  ))
                ) :
                  tableData.length == 0 ? (
                    <tr>
                      <td
                        colSpan={10}
                        style={{
                          textAlign: "center",
                          padding: "40px 16px",
                          fontSize: 13,
                          color: "#9ca3af",
                        }}
                      >
                        No records found.
                      </td>
                    </tr>
                  ) : (
                    // tableData already holds the current page from the server — render directly
                    tableData.map((row, idx) => (
                      <tr
                        key={row.id ?? idx}
                        style={{
                          borderBottom: "1px solid #f3f4f6",
                          background: idx % 2 === 0 ? "#ffffff" : "#fafafa",
                          transition: "background 0.15s",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.background = "#f0fdfa")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.background =
                          idx % 2 === 0 ? "#ffffff" : "#fafafa")
                        }
                      >
                        <td
                          style={{
                            padding: "12px 16px",
                            fontSize: 13,
                            color: "#374151",
                            fontWeight: 500,
                            textAlign: "center",
                          }}
                        >
                          {row?.applicationId}
                        </td>
                        <td
                          style={{
                            padding: "12px 16px",
                            fontSize: 13,
                            color: "#374151",
                            textAlign: "center",
                          }}
                        >
                          {row.customerName}
                        </td>
                        <td style={{ padding: "12px 16px", textAlign: "center" }}>
                          <span
                            style={{
                              ...badge("#0088FF", "white"),
                              borderRadius: 6,
                              fontWeight: 500,
                            }}
                          >
                            {row.bankName}
                          </span>
                        </td>
                        <td style={{ padding: "12px 16px", textAlign: "center" }}>
                          <NachStatusIcon status={row.nachStatus} />
                        </td>
                        <td
                          style={{
                            padding: "12px 16px",
                            fontSize: 13,
                            color: "#374151",
                            textAlign: "center",
                          }}
                        >
                          {row.retryCount}
                        </td>
                        <td style={{ padding: "12px 16px", textAlign: "center" }}>
                          <span
                            style={badge(
                              row.mediumColor?.bg ?? "#ede9fe",
                              row.mediumColor?.color ?? "#7c3aed"
                            )}
                          >
                            {row.medium}
                          </span>
                        </td>
                        <td style={{ padding: "12px 16px", textAlign: "center" }}>
                          <span
                            style={badge(
                              row.loanStatusStyle?.bg ?? "#dcfce7",
                              row.loanStatusStyle?.color ?? "#16a34a"
                            )}
                          >
                            {row.loanStatus}
                          </span>
                        </td>
                        <td
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                          }}
                        >
                          <div style={{ display: "inline-flex", justifyContent: "center" }}>
                            <TruncatedTooltip
                              text={row.failureReason}
                              color={row.failureReasonStyle?.color ?? "#dc2626"}
                              maxLength={20}
                            />
                          </div>
                        </td>
                        <td
                          style={{
                            padding: "12px 16px",
                            textAlign: "center",
                            fontSize: 13,
                            color: "#374151",
                          }}
                        >
                          {row.lastAttempt}
                        </td>
                        <td
                          style={{ padding: "12px 16px", textAlign: "center" }}
                        >
                          <button
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                              fontSize: 18,
                              color: "black",
                              padding: "0 4px",
                              fontWeight: 800,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              setAnchorEl(e.currentTarget);
                              setSelectedRow(row);
                            }}
                          >
                            ⋮
                          </button>
                        </td>
                      </tr>
                    ))
                  )}
              </tbody>
            </table>
          </div>

          {/* ── Pagination (server-side) ── */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              padding: 16,
              borderTop: "1px solid #f3f4f6",
              flexWrap: "wrap",
            }}
          >
            <button
              disabled={currentPage === 0}
              onClick={() => setCurrentPage((p) => Math.max(0, p - 1))}
              style={{
                padding: "6px 12px",
                fontSize: 13,
                borderRadius: 8,
                border: "1px solid #e5e7eb",
                background: "#fff",
                color: "#374151",
                cursor: currentPage === 0 ? "not-allowed" : "pointer",
                opacity: currentPage === 0 ? 0.4 : 1,
              }}
            >
              ← Previous
            </button>

            {pageNumbers?.map((p, i) => {
              // Insert ellipsis between non-consecutive pages
              const prev = pageNumbers[i - 1];
              const showEllipsis = prev && p - prev > 1;
              return (
                <React.Fragment key={p}>
                  {/* {showEllipsis && (
                    <span style={{ padding: "0 4px", color: "#0f54ca", fontSize: 13 }}>
                      …
                    </span>
                  )} */}
                  <button
                    onClick={() => setCurrentPage(p)}
                    style={{
                      // width: 34,
                      // height: 34,
                      borderRadius: 8,
                      border: "1px solid",
                      fontSize: 13,
                      cursor: "pointer",
                      padding: '6px 10px',
                      fontWeight: p === currentPage ? 600 : 400,
                      background: p === currentPage ? "#035865" : "#fff",
                      borderColor: p === currentPage ? "#035865" : "#e5e7eb",
                      color: p === currentPage ? "#fff" : "#374151",
                    }}
                  >
                    {p + 1}
                  </button>
                </React.Fragment>
              );
            })}

            <button
              disabled={currentPage === totalPages - 1}
              onClick={() =>
                setCurrentPage((p) => Math.min(totalPages - 1, p + 1))
              }
              style={{
                padding: "6px 12px",
                fontSize: 13,
                borderRadius: 8,
                border: "1px solid #e5e7eb",
                background: "#fff",
                color: "#374151",
                cursor:
                  currentPage === totalPages - 1 ? "not-allowed" : "pointer",
                opacity: currentPage === totalPages - 1 ? 0.4 : 1,
              }}
            >
              Next →
            </button>
          </div>
        </div>

        {/* ── Charts ── */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: 16,
          }}
        >
          <div style={{ ...card, padding: 20 }}>
            <h3
              style={{
                fontSize: 15,
                fontWeight: 600,
                color: "#111827",
                marginBottom: 16,
                margin: 0,
              }}
            >
              Failure Reason
            </h3>
            <ResponsiveContainer width="100%" height={200}>
              <PieChart>
                <Pie
                  data={FAILURE_PIE}
                  cx="50%"
                  cy="50%"
                  innerRadius={55}
                  outerRadius={85}
                  dataKey="value"
                  paddingAngle={2}
                  startAngle={90}
                  endAngle={-270}
                >
                  {FAILURE_PIE.map((entry, i) => (
                    <Cell key={i} fill={entry.color} />
                  ))}
                </Pie>
                <Tooltip
                  formatter={(v) => `${v}%`}
                  contentStyle={{ fontSize: 12, borderRadius: 8 }}
                />
              </PieChart>
            </ResponsiveContainer>
            <CustomPieLegend data={FAILURE_PIE} />
          </div>

          <div style={{ ...card, padding: 20 }}>
            <h3
              style={{
                fontSize: 15,
                fontWeight: 600,
                color: "#111827",
                margin: "0px 0px 20px 0px",
              }}
            >
              Bank Failure Rate
            </h3>
            <ResponsiveContainer width="100%" height={280}>
              <BarChart
                data={BANK_BAR}
                barSize={36}
                margin={{ top: 4, right: 8, left: -20, bottom: 0 }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  vertical={false}
                  stroke="#f3f4f6"
                />
                <XAxis
                  dataKey="bankName"
                  // angle={-45}
                  // textAnchor="end"
                  // height={70}
                  tick={{ fontSize: 12, fill: "#8A38F5BD" }}
                  axisLine={false}
                  tickLine={false}
                />
                <YAxis
                  tick={{ fontSize: 11, fill: "#8A38F5BD" }}
                  axisLine={false}
                  tickLine={false}
                />
                <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
                <Bar dataKey="failureRatePct" fill="#8A38F5BD" radius={[6, 6, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>

          <div
            style={{
              ...card,
              padding: 20,
              display: "flex",
              flexDirection: "column",
              gap: 12,
            }}
          >
            <h3
              style={{
                fontSize: 15,
                fontWeight: 600,
                color: "#111827",
                display: "flex",
                alignItems: "center",
                gap: 8,
                margin: 0,
              }}
            >
              <span style={{ color: "#d97706" }}>⚠</span> Alerts
            </h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {ALERTS.map((a) => (
                <div
                  key={a.id}
                  style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 10,
                    padding: "12px 14px",
                    borderRadius: 8,
                    background: a.bg,
                    border: `1px solid ${a.border}`,
                  }}
                >
                  <span
                    style={{
                      fontSize: 14,
                      color: a.iconColor,
                      flexShrink: 0,
                    }}
                  >
                    {a.icon}
                  </span>
                  <div>
                    <p
                      style={{
                        fontSize: 13,
                        fontWeight: 600,
                        color: "#1f2937",
                        margin: 0,
                      }}
                    >
                      {a.title}
                    </p>
                    <p
                      style={{
                        fontSize: 12,
                        color: "#6b7280",
                        margin: "2px 0 0",
                      }}
                    >
                      {a.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── Line charts ── */}
        <div
          style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}
        >
          <div style={{ ...card, padding: 20 }}>
            <h3
              style={{
                fontSize: 15,
                fontWeight: 600,
                color: "#111827",
                margin: "0px 0px 20px 0px",
              }}
            >
              Retry Success Rate
            </h3>
            <ResponsiveContainer width="100%" height={200}>
              <LineChart
                data={RETRY_LINE}
                margin={{ top: 4, right: 16, left: -20, bottom: 0 }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  vertical={false}
                  stroke="#f3f4f6"
                />
                <XAxis
                  dataKey="retryNumber"
                  tick={{ fontSize: 12, fill: "#6b7280" }}
                  axisLine={false}
                  tickLine={false}
                />
                <YAxis
                  tick={{ fontSize: 11, fill: "#6b7280" }}
                  axisLine={false}
                  tickLine={false}
                />
                <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
                <Line
                  type="monotone"
                  dataKey="successRatePct"
                  stroke="#10b981"
                  strokeWidth={2.5}
                  dot={{ r: 5, fill: "#10b981", strokeWidth: 0 }}
                  activeDot={{ r: 7 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>

          <div style={{ ...card, padding: 20 }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 16,
              }}
            >
              <h3
                style={{
                  fontSize: 15,
                  fontWeight: 600,
                  color: "#111827",
                  margin: 0,
                }}
              >
                Daily Success vs Fail Trend
              </h3>
              <div style={{ display: "flex", gap: 16 }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    fontSize: 12,
                    color: "#6b7280",
                  }}
                >
                  <span
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      background: "#3b82f6",
                    }}
                  />
                  Success
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 5,
                    fontSize: 12,
                    color: "#6b7280",
                  }}
                >
                  <span
                    style={{
                      width: 10,
                      height: 10,
                      borderRadius: "50%",
                      background: "#f59e0b",
                    }}
                  />
                  Failed
                </div>
              </div>
            </div>
            <ResponsiveContainer width="100%" height={200}>
              <LineChart
                data={DAILY_TREND}
                margin={{ top: 4, right: 16, left: -20, bottom: 0 }}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                  vertical={false}
                  stroke="#f3f4f6"
                />
                <XAxis
                  dataKey="date"
                  tick={{ fontSize: 12, fill: "#6b7280" }}
                  axisLine={false}
                  tickLine={false}
                />
                <YAxis
                  tick={{ fontSize: 11, fill: "#6b7280" }}
                  axisLine={false}
                  tickLine={false}
                />
                <Tooltip contentStyle={{ fontSize: 12, borderRadius: 8 }} />
                <Line
                  type="monotone"
                  dataKey="successCount"
                  stroke="#3b82f6"
                  strokeWidth={2.5}
                  dot={{ r: 5, fill: "#3b82f6", strokeWidth: 0 }}
                  activeDot={{ r: 7 }}
                />
                <Line
                  type="monotone"
                  dataKey="failedCount"
                  stroke="#f59e0b"
                  strokeWidth={2.5}
                  dot={{ r: 5, fill: "#f59e0b", strokeWidth: 0 }}
                  activeDot={{ r: 7 }}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        <ActionMenu
          rowData={selectedRow}
          anchorEl={anchorEl}
          open={menuOpen}
          onClose={() => setAnchorEl(null)}
        />
      </div>
    </>
  );
}